import React, { useState, useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import {
  MDBRow,
  MDBCol,
  MDBBtn,
  MDBIcon,
  MDBInput,
  MDBFileInput,
  MDBSpinner,
} from 'mdbreact';
import NavBar from '../../../components/NavBar';
import api from '../../../services/api';
import { getData } from '../../../services/auth';
import InputMask from 'react-input-mask';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import logotipoDoc from '../../../assets/logotipo_doc_novo.png';
import {
  MASK_CPF,
  MASK_CNPJ,
  MASK_CNH,
  formataCpfCnpj,
} from '../../../utils/mascaras';

// Relatorio Tecnico (RT) - modulo Inteligencia.
// Formulario com o layout do documento oficial. Campos em texto livre +
// multiplos anexos. Cada anexo e enviado a /rt-pdf (1 arquivo por vez); os
// ids retornados sao agregados e enviados no salvar do RT.

// input "cara de documento" p/ os campos do MOTORISTA (no escopo do modulo
// para nao remontar/perder foco a cada tecla).
const campoMotorista = {
  flex: 1,
  minWidth: '120px',
  border: 'none',
  borderBottom: '1px dotted #bbb',
  outline: 'none',
  background: 'transparent',
  fontFamily: 'inherit',
  fontSize: '13px',
};

const rotuloBold = {
  fontSize: '13px',
  whiteSpace: 'nowrap',
};

// Bloco de PJ (Razao social, CNPJ, Data abertura, Capital social, Endereco),
// com titulo, subtitulo opcional e flag "Coincide?" opcional (SIM/NAO como
// checkbox exclusivo). Definido no escopo do modulo para NAO remontar os
// inputs a cada tecla (evita perda de foco).
// props:
//   titulo, subtitulo?
//   dados: { razaoSocial, cnpj, dataAbertura, capitalSocial, endereco }
//   onChange(campo, valor)
//   coincideLabel?  -> se passado, renderiza a linha de flag
//   coincideValor?  ('SIM'|'NAO'|'')  onCoincide?(valor)  coincideAviso?
function BlocoPJ({
  titulo,
  subtitulo,
  idPrefix,
  dados,
  onChange,
  onBuscarCnpj,
  buscando,
  coincideLabel,
  coincideValor,
  onCoincide,
  coincideAviso,
}) {
  const cnpjCompleto = String(dados.cnpj || '').replace(/\D+/g, '').length === 14;
  return (
    <div className="mb-2">
      <div className="font-weight-bold mb-1" style={{ fontSize: '13px' }}>
        {titulo}
      </div>
      {subtitulo && (
        <div
          className="font-italic mb-2"
          style={{ fontSize: '11px', color: '#555' }}
        >
          {subtitulo}
        </div>
      )}

      <div className="d-flex align-items-center mb-1">
        <span className="font-weight-bold mr-2" style={rotuloBold}>
          Razão social:
        </span>
        <input
          type="text"
          value={dados.razaoSocial}
          onChange={e => onChange('razaoSocial', e.target.value)}
          style={campoMotorista}
        />
      </div>

      {/* CNPJ / Data abertura / Capital social na mesma linha */}
      <div className="d-flex align-items-center mb-1 flex-wrap">
        <span className="font-weight-bold mr-2" style={rotuloBold}>
          CNPJ:
        </span>
        <InputMask
          type="text"
          inputMode="numeric"
          mask={MASK_CNPJ}
          maskChar=""
          value={dados.cnpj}
          onChange={e => onChange('cnpj', e.target.value.replace(/\D+/g, ''))}
          style={{ ...campoMotorista, width: '150px' }}
        />
        {/* lupa: habilita so com 14 digitos; busca dados do CNPJ */}
        {onBuscarCnpj && (
          <button
            type="button"
            title={
              cnpjCompleto
                ? 'Buscar dados do CNPJ'
                : 'Digite um CNPJ completo para buscar'
            }
            disabled={!cnpjCompleto || buscando}
            onClick={() =>
              onBuscarCnpj(String(dados.cnpj || '').replace(/\D+/g, ''))
            }
            className="btn btn-link p-0 mr-2"
            style={{
              cursor: cnpjCompleto && !buscando ? 'pointer' : 'not-allowed',
            }}
          >
            <MDBIcon
              icon={buscando ? 'spinner' : 'search'}
              spin={!!buscando}
              style={{ color: cnpjCompleto ? '#0a58ca' : '#bbb' }}
            />
          </button>
        )}
        <span className="font-weight-bold mx-2" style={rotuloBold}>
          Data abertura:
        </span>
        <input
          type="date"
          value={dados.dataAbertura || ''}
          onChange={e => onChange('dataAbertura', e.target.value)}
          style={{ ...campoMotorista, width: '150px' }}
        />
        <span className="font-weight-bold mx-2" style={rotuloBold}>
          Capital social:
        </span>
        <input
          type="text"
          value={dados.capitalSocial}
          onChange={e => onChange('capitalSocial', e.target.value)}
          style={{ ...campoMotorista, width: '120px' }}
        />
      </div>

      <div className="d-flex align-items-center mb-1">
        <span className="font-weight-bold mr-2" style={rotuloBold}>
          Endereço:
        </span>
        <input
          type="text"
          value={dados.endereco}
          onChange={e => onChange('endereco', e.target.value)}
          style={campoMotorista}
        />
      </div>

      {coincideLabel && (
        <div className="d-flex align-items-center mb-1 flex-wrap">
          <span className="font-weight-bold mr-2" style={rotuloBold}>
            {coincideLabel}
          </span>
          <div className="custom-control custom-checkbox mr-3">
            <input
              type="checkbox"
              className="custom-control-input"
              id={`${idPrefix}Sim`}
              checked={coincideValor === 'SIM'}
              onChange={() =>
                onCoincide(coincideValor === 'SIM' ? '' : 'SIM')
              }
            />
            <label
              className="custom-control-label"
              htmlFor={`${idPrefix}Sim`}
              style={{ fontSize: '13px' }}
            >
              SIM
            </label>
          </div>
          <div className="custom-control custom-checkbox">
            <input
              type="checkbox"
              className="custom-control-input"
              id={`${idPrefix}Nao`}
              checked={coincideValor === 'NAO'}
              onChange={() =>
                onCoincide(coincideValor === 'NAO' ? '' : 'NAO')
              }
            />
            <label
              className="custom-control-label"
              htmlFor={`${idPrefix}Nao`}
              style={{ fontSize: '13px' }}
            >
              NÃO
            </label>
          </div>
          {coincideValor === 'NAO' && coincideAviso && (
            <span
              className="ml-3 font-italic"
              style={{ fontSize: '11px', color: '#a00' }}
            >
              {coincideAviso}
            </span>
          )}
        </div>
      )}
    </div>
  );
}

// Repeater de socios (1..N), PF/PJ como checkbox exclusivo. Modulo-escopo p/
// nao remontar. props: titulo, idPrefix, lista, handlers {atualiza,adiciona,
// remove}, socioPreenchido.
function RepeaterSocios({
  titulo,
  idPrefix,
  lista,
  handlers,
  socioPreenchido,
}) {
  return (
    // recuo (indentacao) dos subitens .1 - visualmente "filhos" do item pai,
    // com uma guia vertical a esquerda, como identacao de codigo.
    <div
      className="mb-2"
      style={{
        marginLeft: '24px',
        paddingLeft: '12px',
        borderLeft: '2px solid #e0e0e0',
      }}
    >
      <div className="font-weight-bold mb-1" style={{ fontSize: '13px' }}>
        {titulo}
      </div>

      {lista.map((s, idx) => (
        <div
          key={s._key}
          className="mb-2 pb-1"
          style={{
            borderBottom: idx < lista.length - 1 ? '1px dashed #ddd' : 'none',
          }}
        >
          <div className="d-flex align-items-center mb-1 flex-wrap">
            <span className="font-weight-bold mr-2" style={rotuloBold}>
              Sócio {idx + 1}
            </span>
            {/* tipo PF / PJ como checkbox exclusivo */}
            <div className="custom-control custom-checkbox mr-2">
              <input
                type="checkbox"
                className="custom-control-input"
                id={`${idPrefix}Pf_${s._key}`}
                checked={s.tipo === 'PF'}
                onChange={() => handlers.atualiza(idx, 'tipo', 'PF')}
              />
              <label
                className="custom-control-label"
                htmlFor={`${idPrefix}Pf_${s._key}`}
                style={{ fontSize: '12px' }}
              >
                PF
              </label>
            </div>
            <div className="custom-control custom-checkbox">
              <input
                type="checkbox"
                className="custom-control-input"
                id={`${idPrefix}Pj_${s._key}`}
                checked={s.tipo === 'PJ'}
                onChange={() => handlers.atualiza(idx, 'tipo', 'PJ')}
              />
              <label
                className="custom-control-label"
                htmlFor={`${idPrefix}Pj_${s._key}`}
                style={{ fontSize: '12px' }}
              >
                PJ (Sócio PJ)
              </label>
            </div>
            {lista.length > 1 && (
              <button
                type="button"
                onClick={() => handlers.remove(idx)}
                className="btn btn-link p-0 ml-3"
                style={{ fontSize: '12px', color: '#a00' }}
              >
                remover
              </button>
            )}
          </div>

          <div className="d-flex align-items-center mb-1">
            <span className="font-weight-bold mr-2" style={rotuloBold}>
              Nome:
            </span>
            <input
              type="text"
              value={s.nome}
              onChange={e => handlers.atualiza(idx, 'nome', e.target.value)}
              style={campoMotorista}
            />
          </div>

          <div className="d-flex align-items-center mb-1">
            <span className="font-weight-bold mr-2" style={rotuloBold}>
              {s.tipo === 'PJ' ? 'CNPJ:' : 'CPF:'}
            </span>
            {/* mascara segue o tipo PF/PJ; grava so digitos */}
            <InputMask
              type="text"
              inputMode="numeric"
              mask={s.tipo === 'PJ' ? MASK_CNPJ : MASK_CPF}
              maskChar=""
              value={s.cpf}
              onChange={e =>
                handlers.atualiza(idx, 'cpf', e.target.value.replace(/\D+/g, ''))
              }
              style={campoMotorista}
            />
          </div>

          <div className="d-flex align-items-center mb-1">
            <span className="font-weight-bold mr-2" style={rotuloBold}>
              Endereço:
            </span>
            <input
              type="text"
              value={s.endereco}
              onChange={e => handlers.atualiza(idx, 'endereco', e.target.value)}
              style={campoMotorista}
            />
          </div>

          <div className="d-flex align-items-center mb-1">
            <span className="font-weight-bold mr-2" style={rotuloBold}>
              Registro Criminal:
            </span>
            <input
              type="text"
              value={s.registro_criminal}
              onChange={e =>
                handlers.atualiza(idx, 'registro_criminal', e.target.value)
              }
              style={campoMotorista}
            />
          </div>
        </div>
      ))}

      {socioPreenchido(lista[lista.length - 1]) && (
        <button
          type="button"
          onClick={handlers.adiciona}
          className="btn btn-outline-secondary btn-sm"
          style={{ fontSize: '12px' }}
        >
          + incluir mais um sócio
        </button>
      )}
    </div>
  );
}

// Editor da Dinamica: rich text (react-quill / Quill) com barra de ferramentas
// (negrito, italico, sublinhado, listas, imagem). Aceita colar/inserir imagens
// que viram <img src="data:...base64"> inline. Guarda o conteudo como HTML.
// Definido no escopo do modulo p/ nao remontar.
//   value: HTML controlado; onChange(html): recebe o HTML do editor.

// converte um File de imagem em dataURL base64 e insere no editor Quill
function insereImagemNoQuill(editor, arquivo) {
  const reader = new FileReader();
  reader.onload = ev => {
    const range = editor.getSelection(true);
    const pos = range ? range.index : editor.getLength();
    editor.insertEmbed(pos, 'image', ev.target.result, 'user');
    editor.setSelection(pos + 1, 0);
  };
  reader.readAsDataURL(arquivo);
}

function EditorDinamica({ value, onChange }) {
  const quillRef = useRef(null);

  // handler do botao de imagem da toolbar: abre seletor e insere base64
  const selecionaImagem = () => {
    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.setAttribute('accept', 'image/*');
    input.onchange = () => {
      const arquivo = input.files && input.files[0];
      if (arquivo && quillRef.current) {
        insereImagemNoQuill(quillRef.current.getEditor(), arquivo);
      }
    };
    input.click();
  };

  // colar/arrastar imagem direto na area: converte p/ base64 e insere
  useEffect(() => {
    if (!quillRef.current) return undefined;
    const editor = quillRef.current.getEditor();
    const root = editor.root;

    const aoColar = e => {
      const items = (e.clipboardData && e.clipboardData.items) || [];
      for (let i = 0; i < items.length; i += 1) {
        if (items[i].type && items[i].type.indexOf('image') === 0) {
          const arquivo = items[i].getAsFile();
          if (arquivo) {
            e.preventDefault();
            insereImagemNoQuill(editor, arquivo);
          }
        }
      }
    };
    const aoSoltar = e => {
      const arquivos = (e.dataTransfer && e.dataTransfer.files) || [];
      for (let i = 0; i < arquivos.length; i += 1) {
        if (arquivos[i].type && arquivos[i].type.indexOf('image') === 0) {
          e.preventDefault();
          insereImagemNoQuill(editor, arquivos[i]);
        }
      }
    };

    root.addEventListener('paste', aoColar, true);
    root.addEventListener('drop', aoSoltar, true);
    return () => {
      root.removeEventListener('paste', aoColar, true);
      root.removeEventListener('drop', aoSoltar, true);
    };
  }, []);

  // modulos memoizados (o image handler precisa referenciar selecionaImagem).
  // toolbar completa: cabecalhos, fonte, tamanho, cor, alinhamento, listas,
  // indentacao, citacao/codigo, sub/sobrescrito, link, imagem, limpar.
  const modulos = useRef({
    toolbar: {
      container: [
        [{ header: [1, 2, 3, false] }],
        [{ size: ['small', false, 'large', 'huge'] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ color: [] }, { background: [] }],
        [{ align: [] }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ indent: '-1' }, { indent: '+1' }],
        [{ script: 'sub' }, { script: 'super' }],
        ['blockquote', 'code-block'],
        ['link', 'image'],
        ['clean'],
      ],
      handlers: { image: selecionaImagem },
    },
    clipboard: { matchVisual: false },
  }).current;

  return (
    <div className="rt-dinamica-editor">
      <ReactQuill
        ref={quillRef}
        theme="snow"
        value={value || ''}
        onChange={onChange}
        modules={modulos}
        placeholder="Descreva a dinâmica... (você pode colar/inserir imagens)"
        style={{ background: '#fff' }}
      />
    </div>
  );
}

export default function RelatorioTecnico(props) {
  const history = useHistory();

  // tipo do documento: INTELIGENCIA (padrao) ou CONTRA_INTELIGENCIA (prop
  // injetada pela rota /ci-...). Define a serie do numero e o retorno.
  const tipo = props.tipo || 'INTELIGENCIA';
  const ehRelintCi = tipo === 'RELINT_CI';
  // RELINT_CI usa o mesmo layout do RELINT (campo Avaliacao + renumeracao),
  // muda apenas modulo/menu/numeracao e as rotas de retorno.
  const ehRelint = tipo === 'RELINT' || ehRelintCi;
  const ehPedidoBuscaCi = tipo === 'PEDIDO_BUSCA_CI';
  const ehPedidoBusca = tipo === 'PEDIDO_BUSCA' || ehPedidoBuscaCi;
  const ehOrdemBuscaCi = tipo === 'ORDEM_BUSCA_CI';
  const ehOrdemBusca = tipo === 'ORDEM_BUSCA' || ehOrdemBuscaCi;
  // Pedido de Busca e Ordem de Busca tem o MESMO layout (sem Dinamica, com os
  // 3 campos de texto). So mudam nomenclatura, numeracao, rotas e ACL.
  const ehSemDinamica = ehPedidoBusca || ehOrdemBusca;

  // rotulo do botao Salvar por tipo (map em vez de ternario aninhado, que
  // antes dos hooks confunde o eslint-plugin-react-hooks e quebra o build).
  const NOMES_DOCUMENTO = {
    PEDIDO_BUSCA: 'Pedido de Busca',
    PEDIDO_BUSCA_CI: 'Pedido de Busca',
    ORDEM_BUSCA: 'Ordem de Busca',
    ORDEM_BUSCA_CI: 'Ordem de Busca',
    RELATORIO_AGENTE: 'Relatório de Agente',
    RELATORIO_AGENTE_CI: 'Relatório de Agente',
    RELINT: 'RELINT',
    RELINT_CI: 'RELINT',
  };
  const nomeDocumento = NOMES_DOCUMENTO[tipo] || 'Relatório Técnico';

  // prefixo-BASE do cabecalho (sem o sufixo): o sufixo e a sigla de agencia do
  // autor (ou S181 quando nao ha). RT default mantem o texto historico GSI/SAOECD.
  const PREFIXOS_DOC = {
    PEDIDO_BUSCA: 'PB SESEG/SSINTE/',
    PEDIDO_BUSCA_CI: 'PB SESEG/SSINTE/',
    ORDEM_BUSCA: 'OB SESEG/SSINTE/',
    ORDEM_BUSCA_CI: 'OB SESEG/SSINTE/',
    RELATORIO_AGENTE: 'RA SESEG/SSINTE/',
    RELATORIO_AGENTE_CI: 'RA SESEG/SSINTE/',
    RELINT: 'RELINT SESEG/SSINTE/',
    RELINT_CI: 'RELINT SESEG/SSINTE/',
  };
  const prefixoBaseDoc = PREFIXOS_DOC[tipo] || 'RT GSI/SAOECD/';

  // sigla de agencia do usuario logado (preview do cabecalho; o snapshot real
  // e gravado pelo backend no salvar). Cada modulo tem a SUA sigla: documento
  // de Contra Inteligencia usa sigla_agencia_ci; os demais, sigla_agencia.
  const ehTipoCi = tipo === 'CONTRA_INTELIGENCIA' || tipo.endsWith('_CI');
  const [minhaSigla, setMinhaSigla] = useState('');
  useEffect(() => {
    api
      .get(`/usuario/${getData().id}`)
      .then(r =>
        setMinhaSigla(
          (ehTipoCi ? r.data?.sigla_agencia_ci : r.data?.sigla_agencia) || ''
        )
      )
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // criador RESTRITO: o PCF e fixo na gerencia dele (o servidor tambem forca).
  const pcfTravado = props.restritoGerencia === true;
  useEffect(() => {
    if (!pcfTravado) return;
    api
      .get('/relint-pcf-gerencia')
      .then(r => setPcf(r.data?.pcf || ''))
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // rota de retorno pos-salvar por tipo (map evita ternario gigante).
  const ROTAS_RETORNO = {
    PEDIDO_BUSCA: '/pedidos-busca',
    PEDIDO_BUSCA_CI: '/ci-pedidos-busca',
    ORDEM_BUSCA: '/ordens-busca',
    ORDEM_BUSCA_CI: '/ci-ordens-busca',
    RELATORIO_AGENTE: '/relatorios-agente',
    RELATORIO_AGENTE_CI: '/ci-relatorios-agente',
    RELINT: '/relints',
    RELINT_CI: '/ci-relints',
    CONTRA_INTELIGENCIA: '/ci-relatorios-tecnicos',
  };
  // ACL de escopo: quem criou pela rota restrita volta p/ a listagem restrita
  // (nao tem acesso a /relints).
  const rotaRetorno =
    props.restritoGerencia === true
      ? '/relints-gerencia'
      : ROTAS_RETORNO[tipo] || '/relatorios-tecnicos';

  // data pre-preenchida com hoje (yyyy-MM-dd p/ o input date); editavel
  const hojeISO = new Date().toISOString().slice(0, 10);
  const [data, setData] = useState(hojeISO);
  const [assunto, setAssunto] = useState('');
  const [origem, setOrigem] = useState('');
  const [avaliacao, setAvaliacao] = useState('');
  const [difusao, setDifusao] = useState('');
  const [difusaoAnterior, setDifusaoAnterior] = useState('');
  const [referencia, setReferencia] = useState('');
  const [dinamica, setDinamica] = useState('');
  const [dadosConhecidos, setDadosConhecidos] = useState('');
  const [dadosSolicitados, setDadosSolicitados] = useState('');
  const [instrucoesEspeciais, setInstrucoesEspeciais] = useState('');
  const [pcf, setPcf] = useState('');
  const [precedencia, setPrecedencia] = useState('');

  // dados do MOTORISTA (bloco dentro da dinamica, abaixo do PCF)
  const [motoristaNome, setMotoristaNome] = useState('');
  const [motoristaCpf, setMotoristaCpf] = useState('');
  const [motoristaCnh, setMotoristaCnh] = useState('');
  const [motoristaCat, setMotoristaCat] = useState('');
  const [motoristaValidade, setMotoristaValidade] = useState('');
  const [motoristaEndereco, setMotoristaEndereco] = useState('');
  const [motoristaRegistroCriminal, setMotoristaRegistroCriminal] = useState(
    ''
  );

  // VEICULO (cavalo mecanico) - abaixo do motorista
  const [veiculoMarcaModelo, setVeiculoMarcaModelo] = useState('');
  const [veiculoTipo, setVeiculoTipo] = useState('');
  const [veiculoPlaca, setVeiculoPlaca] = useState('');
  const [veiculoCor, setVeiculoCor] = useState('');
  const [veiculoAno, setVeiculoAno] = useState('');
  const [veiculoChassi, setVeiculoChassi] = useState('');
  const [veiculoProprietario, setVeiculoProprietario] = useState('');
  const [veiculoCpfCnpj, setVeiculoCpfCnpj] = useState('');

  // VEICULO (semirreboque) - somente nos casos em que houver
  const [semiPlaca, setSemiPlaca] = useState('');
  const [semiChassi, setSemiChassi] = useState('');
  const [semiProprietario, setSemiProprietario] = useState('');
  const [semiCpfCnpj, setSemiCpfCnpj] = useState('');

  // 4. PJ REMETENTE DA CARGA
  const [pjRazaoSocial, setPjRazaoSocial] = useState('');
  const [pjCnpj, setPjCnpj] = useState('');
  const [pjDataAbertura, setPjDataAbertura] = useState('');
  const [pjCapitalSocial, setPjCapitalSocial] = useState('');
  const [pjEndereco, setPjEndereco] = useState('');
  const [coincideNfe, setCoincideNfe] = useState(''); // 'SIM' | 'NAO'

  // 5. PJ EMITENTE DA NF-e (so exibido/impresso quando coincideNfe === 'NAO')
  const [emitenteRazaoSocial, setEmitenteRazaoSocial] = useState('');
  const [emitenteCnpj, setEmitenteCnpj] = useState('');
  const [emitenteDataAbertura, setEmitenteDataAbertura] = useState('');
  const [emitenteCapitalSocial, setEmitenteCapitalSocial] = useState('');
  const [emitenteEndereco, setEmitenteEndereco] = useState('');

  // helper: novo socio em branco, com _key estavel (evita remontar/perder foco)
  const novoSocio = k => ({
    _key: k,
    nome: '',
    cpf: '',
    endereco: '',
    registro_criminal: '',
    tipo: 'PF',
  });

  // 4.1 SOCIOS (PJ Remetente) - lista dinamica (1..N)
  const [socios, setSocios] = useState([novoSocio('r0')]);
  // 5.1 SOCIOS (PJ Emitente) - lista dinamica (1..N)
  const [sociosEmitente, setSociosEmitente] = useState([novoSocio('e0')]);
  // 6.1 SOCIOS (PJ Transportadora)
  const [sociosTransp, setSociosTransp] = useState([novoSocio('t0')]);
  // 7.1 SOCIOS (PJ Emitente do Manifesto)
  const [sociosManifesto, setSociosManifesto] = useState([novoSocio('m0')]);
  // 8.1 SOCIOS (PJ Destinatario)
  const [sociosDest, setSociosDest] = useState([novoSocio('d0')]);
  // contador global p/ gerar _key unico sem depender de indice
  const socioSeq = useRef(1);

  // fabrica de handlers para um repeater de socios (reusado por 4.1 e 5.1)
  const criaHandlersSocio = (setLista, prefixo) => ({
    atualiza: (idx, campo, valor) =>
      setLista(lista =>
        lista.map((s, i) => (i === idx ? { ...s, [campo]: valor } : s))
      ),
    adiciona: () => {
      const k = `${prefixo}${socioSeq.current}`;
      socioSeq.current += 1;
      setLista(lista => [...lista, novoSocio(k)]);
    },
    remove: idx => setLista(lista => lista.filter((s, i) => i !== idx)),
  });

  const socioRemetente = criaHandlersSocio(setSocios, 'r');
  const socioEmitente = criaHandlersSocio(setSociosEmitente, 'e');
  const socioTransp = criaHandlersSocio(setSociosTransp, 't');
  const socioManifesto = criaHandlersSocio(setSociosManifesto, 'm');
  const socioDest = criaHandlersSocio(setSociosDest, 'd');

  // wrappers p/ manter o JSX do 4.1 inalterado
  const atualizaSocio = socioRemetente.atualiza;
  const adicionaSocio = socioRemetente.adiciona;
  const removeSocio = socioRemetente.remove;

  // um socio "tem conteudo" se qualquer campo textual estiver preenchido
  const socioPreenchido = s =>
    !!(s.nome || s.cpf || s.endereco || s.registro_criminal);

  // 6/7/8 PJ como estado-objeto (usado pelo componente BlocoPJ)
  const pjVazio = {
    razaoSocial: '',
    cnpj: '',
    dataAbertura: '',
    capitalSocial: '',
    endereco: '',
  };
  const [transp, setTransp] = useState({ ...pjVazio });
  const [coincideCte, setCoincideCte] = useState(''); // 'SIM' | 'NAO'
  const [manifesto, setManifesto] = useState({ ...pjVazio });
  const [dest, setDest] = useState({ ...pjVazio });

  const mudaPj = setter => (campo, valor) =>
    setter(prev => ({ ...prev, [campo]: valor }));

  // qual bloco esta consultando CNPJ agora (p/ spinner na lupa). Guarda a
  // chave do bloco ('pj','emitente','transp','manifesto','dest') ou ''.
  const [buscandoCnpj, setBuscandoCnpj] = useState('');

  // dd/MM/yyyy -> yyyy-MM-dd (formato do input date). Retorna '' se invalido.
  const dataBrParaIso = v => {
    const m = String(v || '').match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
    return m ? `${m[3]}-${m[2]}-${m[1]}` : '';
  };

  // monta o endereco num texto unico a partir das partes do retorno
  const montaEndereco = d => {
    const linha1 = [d.logradouro, d.numero, d.complemento]
      .filter(x => x && String(x).trim())
      .join(', ');
    const linha2 = [d.bairro, d.municipio && `${d.municipio}${d.uf ? '/' + d.uf : ''}`]
      .filter(x => x && String(x).trim())
      .join(' - ');
    const cep = d.cep ? `CEP ${d.cep}` : '';
    return [linha1, linha2, cep].filter(x => x).join(' - ');
  };

  // consulta o CNPJ no backend e preenche o bloco (aplica) + socios da secao.
  //  chave: identifica o bloco p/ o spinner
  //  cnpjDigitos: 14 digitos
  //  aplica({razaoSocial,dataAbertura,endereco}): grava no bloco correspondente
  //  setListaSocios, prefixoSocio: substitui a lista de socios da secao
  const buscaCnpj = async (chave, cnpjDigitos, aplica, setListaSocios, prefixoSocio) => {
    if (!cnpjDigitos || cnpjDigitos.length !== 14) return;
    setBuscandoCnpj(chave);
    try {
      const { data: d } = await api.get('/rt-consulta-cnpj', {
        params: { cnpj: cnpjDigitos },
      });
      if (!d || d.erro) {
        toast.error(d?.erro || 'CNPJ não encontrado');
        return;
      }

      aplica({
        razaoSocial: d.nome_empresarial || d.nome_fantasia || '',
        dataAbertura: dataBrParaIso(d.data_abertura),
        endereco: montaEndereco(d),
      });

      // socios: nome (+ qualificacao) e CPF vazio (vem mascarado da Receita)
      if (Array.isArray(d.socios) && d.socios.length > 0) {
        const lista = d.socios.map((s, i) => {
          const k = `${prefixoSocio}c${socioSeq.current}`;
          socioSeq.current += 1;
          const nome = s.qualificacao
            ? `${s.nome} (${s.qualificacao})`
            : s.nome || '';
          return {
            _key: k,
            nome,
            cpf: '',
            endereco: '',
            registro_criminal: '',
            tipo: 'PF',
          };
        });
        setListaSocios(lista);
      }

      toast.success('Dados do CNPJ preenchidos');
    } catch (e) {
      toast.error('Falha ao consultar o CNPJ');
    } finally {
      setBuscandoCnpj('');
    }
  };

  // anexos ja enviados: [{ id, nome }]
  const [anexos, setAnexos] = useState([]);
  const [arquivoSelecionado, setArquivoSelecionado] = useState('');
  const [descricaoNova, setDescricaoNova] = useState('');
  const [enviandoAnexo, setEnviandoAnexo] = useState(false);
  const [salvando, setSalvando] = useState(false);

  // envia 1 arquivo -> guarda o id retornado. Descricao obrigatoria (preenchida
  // ANTES de anexar) e ja associada ao anexo.
  const adicionaAnexo = async () => {
    if (descricaoNova.trim() === '') {
      toast.error('Preencha a descrição do anexo');
      return;
    }
    if (!arquivoSelecionado || arquivoSelecionado === '') {
      toast.error('Selecione um arquivo');
      return;
    }
    setEnviandoAnexo(true);
    try {
      const formData = new FormData();
      formData.append('file', arquivoSelecionado);
      const response = await api.post('/rt-pdf', formData);
      if (response.data && response.data.id) {
        setAnexos(prev => [
          ...prev,
          {
            id: response.data.id,
            nome: response.data.nome,
            descricao: descricaoNova.trim(),
          },
        ]);
        setArquivoSelecionado('');
        setDescricaoNova('');
      } else {
        toast.error('Falha ao anexar o arquivo');
      }
    } catch (e) {
      toast.error('Falha ao anexar o arquivo');
    }
    setEnviandoAnexo(false);
  };

  const removeAnexo = async id => {
    try {
      await api.delete(`/rt-pdf/${id}`);
    } catch (e) {
      // mesmo se falhar no back, removemos da lista local
    }
    setAnexos(prev => prev.filter(a => a.id !== id));
  };

  // mapeia uma lista de socios do repeater p/ o payload (so os preenchidos)
  const mapaSocios = lista =>
    lista.filter(socioPreenchido).map(s => ({
      nome: s.nome,
      cpf: s.cpf,
      endereco: s.endereco,
      registro_criminal: s.registro_criminal,
      tipo: s.tipo,
    }));

  const salvar = async () => {
    if (assunto.trim() === '') {
      toast.error('Preencha o Assunto');
      return;
    }
    // PCF obrigatorio no RELINT: define o posto do documento (e quem o enxerga)
    if (tipo === 'RELINT' && String(pcf || '').trim() === '') {
      toast.error('Selecione o PCF (Posto de Controle Fiscal)');
      return;
    }
    setSalvando(true);
    try {
      const result = await api.post('/relatorio-tecnico', {
        tipo,
        data: data === '' ? null : data,
        assunto,
        origem,
        avaliacao,
        difusao,
        difusao_anterior: difusaoAnterior,
        referencia,
        dinamica,
        dados_conhecidos: dadosConhecidos,
        dados_solicitados: dadosSolicitados,
        instrucoes_especiais: instrucoesEspeciais,
        pcf,
        precedencia,
        motorista_nome: motoristaNome,
        motorista_cpf: motoristaCpf,
        motorista_cnh: motoristaCnh,
        motorista_cat: motoristaCat,
        motorista_validade: motoristaValidade,
        motorista_endereco: motoristaEndereco,
        motorista_registro_criminal: motoristaRegistroCriminal,
        veiculo_marca_modelo: veiculoMarcaModelo,
        veiculo_tipo: veiculoTipo,
        veiculo_placa: veiculoPlaca,
        veiculo_cor: veiculoCor,
        veiculo_ano: veiculoAno,
        veiculo_chassi: veiculoChassi,
        veiculo_proprietario: veiculoProprietario,
        veiculo_cpf_cnpj: veiculoCpfCnpj,
        semirreboque_placa: semiPlaca,
        semirreboque_chassi: semiChassi,
        semirreboque_proprietario: semiProprietario,
        semirreboque_cpf_cnpj: semiCpfCnpj,
        pj_razao_social: pjRazaoSocial,
        pj_cnpj: pjCnpj,
        pj_data_abertura: pjDataAbertura,
        pj_capital_social: pjCapitalSocial,
        pj_endereco: pjEndereco,
        coincide_nfe: coincideNfe,
        socios: mapaSocios(socios),
        // 5. PJ EMITENTE + 5.1 socios: so enviados quando ha divergencia (NAO)
        emitente_razao_social: coincideNfe === 'NAO' ? emitenteRazaoSocial : '',
        emitente_cnpj: coincideNfe === 'NAO' ? emitenteCnpj : '',
        emitente_data_abertura:
          coincideNfe === 'NAO' ? emitenteDataAbertura : '',
        emitente_capital_social:
          coincideNfe === 'NAO' ? emitenteCapitalSocial : '',
        emitente_endereco: coincideNfe === 'NAO' ? emitenteEndereco : '',
        socios_emitente:
          coincideNfe === 'NAO' ? mapaSocios(sociosEmitente) : [],
        // 6. PJ TRANSPORTADORA + 6.1 socios
        transp_razao_social: transp.razaoSocial,
        transp_cnpj: transp.cnpj,
        transp_data_abertura: transp.dataAbertura,
        transp_capital_social: transp.capitalSocial,
        transp_endereco: transp.endereco,
        coincide_cte: coincideCte,
        socios_transp: mapaSocios(sociosTransp),
        // 7. PJ EMITENTE DO MANIFESTO + 7.1: so quando ha divergencia (NAO)
        manifesto_razao_social:
          coincideCte === 'NAO' ? manifesto.razaoSocial : '',
        manifesto_cnpj: coincideCte === 'NAO' ? manifesto.cnpj : '',
        manifesto_data_abertura:
          coincideCte === 'NAO' ? manifesto.dataAbertura : '',
        manifesto_capital_social:
          coincideCte === 'NAO' ? manifesto.capitalSocial : '',
        manifesto_endereco: coincideCte === 'NAO' ? manifesto.endereco : '',
        socios_manifesto:
          coincideCte === 'NAO' ? mapaSocios(sociosManifesto) : [],
        // 8. PJ DESTINATARIO + 8.1 socios (sempre)
        dest_razao_social: dest.razaoSocial,
        dest_cnpj: dest.cnpj,
        dest_data_abertura: dest.dataAbertura,
        dest_capital_social: dest.capitalSocial,
        dest_endereco: dest.endereco,
        socios_dest: mapaSocios(sociosDest),
        anexos: anexos.map(a => ({ id: a.id, descricao: a.descricao })),
      });
      if (result.data && result.data.sucesso) {
        toast.success(result.data.sucesso);
        history.push(rotaRetorno);
      } else {
        toast.error(result.data?.erro || `Falha ao salvar ${nomeDocumento}`);
      }
    } catch (e) {
      toast.error(`Falha ao salvar ${nomeDocumento}`);
    }
    setSalvando(false);
  };

  return (
    <NavBar>
      {/* MESA (fundo) */}
      <div style={{ background: '#c7cdd6', padding: '24px 0', minHeight: '100%' }}>
        {/* FOLHA A4 (pagina branca com margens internas, como o documento) */}
        <div
          style={{
            maxWidth: '820px',
            margin: '0 auto',
            fontFamily: 'Times New Roman, Georgia, serif',
            color: '#000',
            background: '#fff',
            padding: '28px 40px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.25)',
          }}
        >
          {/* RESERVADO (topo) */}
          <div className="text-center font-weight-bold mb-2" style={{ color: '#c00' }}>
            RESERVADO
          </div>


          {/* MOLDURA do documento */}
          <div
            style={{
              border: '1px solid #000',
              padding: '18px 22px',
              minHeight: '620px',
              position: 'relative',
            }}
          >
            {/* pagina 1/1 */}
            <div style={{ position: 'absolute', top: 8, right: 12, fontSize: '11px' }}>
              1/1
            </div>

            {/* brasao + cabecalho */}
            <div className="text-center">
              <img
                src={logotipoDoc}
                alt="brasão"
                style={{ width: '58px', height: '58px', objectFit: 'contain' }}
              />
              <p className="m-0" style={{ fontSize: '11px' }}>
                Governo do Estado do Rio de Janeiro
              </p>
              <p className="m-0" style={{ fontSize: '11px' }}>
                Secretaria de Estado de Segurança
              </p>
              <p className="m-0" style={{ fontSize: '11px' }}>
                Subsecretaria de Inteligência
              </p>
            </div>

            {/* PRECEDENCIA (caixa vermelha a esquerda) - agora e um select.
                O valor escolhido aparece dentro da caixa vermelha. */}
            <div className="my-2">
              <span
                className="font-weight-bold px-2"
                style={{ color: '#c00', border: '2px solid #c00', display: 'inline-block' }}
              >
                <select
                  value={precedencia}
                  onChange={e => setPrecedencia(e.target.value)}
                  style={{
                    border: 'none',
                    outline: 'none',
                    background: 'transparent',
                    color: '#c00',
                    fontWeight: 'bold',
                    fontFamily: 'inherit',
                    cursor: 'pointer',
                  }}
                >
                  <option value="">PRECEDÊNCIA</option>
                  <option value="Urgentíssimo">URGENTÍSSIMO</option>
                  <option value="Urgente">URGENTE</option>
                  <option value="Normal">NORMAL</option>
                </select>
              </span>
            </div>

            {/* numero do documento */}
            <p className="font-weight-bold" style={{ fontSize: '13px' }}>
              {`${prefixoBaseDoc}${minhaSigla || 'S181'} nº 0000/AAAA`}{' '}
              <span className="font-italic font-weight-normal">
                (número gerado ao salvar)
              </span>
            </p>

            {/* CAMPOS 1-7 (estilo documento) */}
            {/* 1. Data */}
            <div className="d-flex align-items-center mb-1">
              <span className="font-weight-bold mr-2" style={{ fontSize: '13px' }}>
                1. Data:
              </span>
              <input
                type="date"
                value={data}
                onChange={e => setData(e.target.value)}
                style={{
                  border: 'none',
                  borderBottom: '1px dotted #bbb',
                  outline: 'none',
                  background: 'transparent',
                  fontFamily: 'inherit',
                  fontSize: '13px',
                }}
              />
            </div>

            <span className="font-weight-bold" style={{ fontSize: '13px' }}>
              2. Assunto:
            </span>
            <MDBInput
              type="textarea"
              rows="2"
              value={assunto}
              onChange={e => setAssunto(e.target.value)}
            />

            <span className="font-weight-bold" style={{ fontSize: '13px' }}>
              3. Origem:
            </span>
            <MDBInput
              type="textarea"
              rows="2"
              value={origem}
              onChange={e => setOrigem(e.target.value)}
            />

            {ehRelint && (
              <>
                <span
                  className="font-weight-bold"
                  style={{ fontSize: '13px' }}
                >
                  4. Avaliação:
                </span>
                <span
                  className="font-italic ml-2"
                  style={{ fontSize: '11px', color: '#555' }}
                >
                  (só preencher no conhecimento do tipo Informe)
                </span>
                <MDBInput
                  type="textarea"
                  rows="2"
                  value={avaliacao}
                  onChange={e => setAvaliacao(e.target.value)}
                />
              </>
            )}

            <span className="font-weight-bold" style={{ fontSize: '13px' }}>
              {ehRelint ? '5. Difusão:' : '4. Difusão:'}
            </span>
            <MDBInput
              type="textarea"
              rows="2"
              value={difusao}
              onChange={e => setDifusao(e.target.value)}
            />

            <span className="font-weight-bold" style={{ fontSize: '13px' }}>
              {ehRelint ? '6. Difusão Anterior:' : '5. Difusão Anterior:'}
            </span>
            <MDBInput
              type="textarea"
              rows="2"
              value={difusaoAnterior}
              onChange={e => setDifusaoAnterior(e.target.value)}
            />

            <span className="font-weight-bold" style={{ fontSize: '13px' }}>
              {ehRelint ? '7. Referência:' : '6. Referência:'}
            </span>
            <MDBInput
              type="textarea"
              rows="2"
              value={referencia}
              onChange={e => setReferencia(e.target.value)}
            />

            {/* 7. Anexos */}
            <div className="d-flex mb-1" style={{ alignItems: 'flex-start' }}>
              <span className="font-weight-bold mr-2" style={{ fontSize: '13px', whiteSpace: 'nowrap' }}>
                {ehRelint ? '8. Anexo:' : '7. Anexo:'}
              </span>
              <div style={{ width: '100%' }}>
                {anexos.map(a => (
                  <div key={a.id} className="mb-1">
                    <div
                      className="d-flex align-items-center justify-content-between"
                      style={{ fontSize: '13px' }}
                    >
                      {/* descricao (principal) + nome do arquivo (referencia) */}
                      <span>
                        <MDBIcon
                          far
                          icon="file-pdf"
                          className="mr-1 text-danger"
                        />
                        {a.descricao}
                        <span
                          className="grey-text ml-2 d-print-none"
                          style={{ fontSize: '11px' }}
                        >
                          ({a.nome})
                        </span>
                      </span>
                      <span
                        className="danger-text d-print-none"
                        style={{ cursor: 'pointer', fontSize: '12px' }}
                        onClick={() => removeAnexo(a.id)}
                      >
                        <MDBIcon far icon="trash-alt" className="mr-1" />
                        remover
                      </span>
                    </div>
                  </div>
                ))}
                {/* adicionar anexo (nao entra no documento impresso).
                    a DESCRICAO e obrigatoria e preenchida ANTES de anexar. */}
                <div className="d-print-none mt-2">
                  <input
                    type="text"
                    placeholder="Descrição do anexo (obrigatória)"
                    value={descricaoNova}
                    onChange={e => setDescricaoNova(e.target.value)}
                    style={{
                      width: '100%',
                      border: '1px solid #ced4da',
                      borderRadius: '4px',
                      outline: 'none',
                      background: '#fff',
                      fontFamily: 'inherit',
                      fontSize: '13px',
                      padding: '4px 8px',
                      marginBottom: '8px',
                    }}
                  />
                  <MDBRow className="align-items-center">
                    <MDBCol size="12" md="8">
                      <MDBFileInput
                        textFieldTitle="Selecione um arquivo"
                        btnTitle="Procurar"
                        btnColor="default"
                        getValue={e => setArquivoSelecionado(e[0])}
                      />
                    </MDBCol>
                    <MDBCol size="12" md="4">
                      <MDBBtn
                        color="info"
                        size="sm"
                        disabled={enviandoAnexo}
                        onClick={adicionaAnexo}
                      >
                        {enviandoAnexo ? (
                          <MDBSpinner small />
                        ) : (
                          <>
                            <MDBIcon icon="plus" className="mr-1" />
                            Anexar
                          </>
                        )}
                      </MDBBtn>
                    </MDBCol>
                  </MDBRow>
                </div>
              </div>
            </div>

            {!ehSemDinamica && (
              <>
            {/* linha horizontal (como no documento impresso) */}
            <hr style={{ borderTop: '1px solid #000' }} />

            {/* 8. Dinamica (texto livre) */}
            <span className="font-weight-bold" style={{ fontSize: '13px' }}>
              {ehRelint ? '9. Dinâmica:' : '8. Dinâmica:'}
            </span>

            {/* PCF - Posto de Controle Fiscal (dentro da area da Dinamica) */}
            <div className="d-flex align-items-center mb-2 mt-1">
              <span
                className="font-weight-bold mr-2"
                style={{ fontSize: '13px', whiteSpace: 'nowrap' }}
              >
                {`PCF (Posto de Controle Fiscal):${tipo === 'RELINT' ? ' *' : ''}`}
              </span>
              <select
                value={pcf}
                disabled={pcfTravado}
                onChange={e => setPcf(e.target.value)}
                style={{
                  border: 'none',
                  borderBottom: '1px dotted #bbb',
                  outline: 'none',
                  background: 'transparent',
                  fontFamily: 'inherit',
                  fontSize: '13px',
                }}
              >
                <option value="">Selecione...</option>
                <option value="Nhangapi">Nhangapi</option>
                <option value="Levy Gasparian">Levy Gasparian</option>
                <option value="Mato Verde (Morro do Coco)">
                  Mato Verde (Morro do Coco)
                </option>
                <option value="Timbó">Timbó</option>
                <option value="Angra dos Reis">Angra dos Reis</option>
              </select>
              {pcfTravado && (
                <span
                  className="font-italic ml-2"
                  style={{ fontSize: '11px', color: '#777' }}
                >
                  (fixo na sua gerência)
                </span>
              )}
            </div>

            {/* BLOCO MOTORISTA (dentro da dinamica, abaixo do PCF) */}
            <div className="mb-2">
              <div
                className="font-weight-bold mb-1"
                style={{ fontSize: '13px' }}
              >
                MOTORISTA
              </div>

              <div className="d-flex align-items-center mb-1">
                <span
                  className="font-weight-bold mr-2"
                  style={{ fontSize: '13px', whiteSpace: 'nowrap' }}
                >
                  Nome:
                </span>
                <input
                  type="text"
                  value={motoristaNome}
                  onChange={e => setMotoristaNome(e.target.value)}
                  style={campoMotorista}
                />
              </div>

              <div className="d-flex align-items-center mb-1">
                <span
                  className="font-weight-bold mr-2"
                  style={{ fontSize: '13px', whiteSpace: 'nowrap' }}
                >
                  CPF:
                </span>
                <InputMask
                  type="text"
                  inputMode="numeric"
                  mask={MASK_CPF}
                  maskChar=""
                  value={motoristaCpf}
                  onChange={e =>
                    setMotoristaCpf(e.target.value.replace(/\D+/g, ''))
                  }
                  style={campoMotorista}
                />
              </div>

              {/* CNH / Cat / Validade na mesma linha */}
              <div className="d-flex align-items-center mb-1 flex-wrap">
                <span
                  className="font-weight-bold mr-2"
                  style={{ fontSize: '13px', whiteSpace: 'nowrap' }}
                >
                  CNH:
                </span>
                <InputMask
                  type="text"
                  inputMode="numeric"
                  mask={MASK_CNH}
                  maskChar=""
                  value={motoristaCnh}
                  onChange={e =>
                    setMotoristaCnh(e.target.value.replace(/\D+/g, ''))
                  }
                  style={{ ...campoMotorista, width: '120px' }}
                />
                <span
                  className="font-weight-bold mx-2"
                  style={{ fontSize: '13px', whiteSpace: 'nowrap' }}
                >
                  Cat.:
                </span>
                <input
                  type="text"
                  value={motoristaCat}
                  onChange={e => setMotoristaCat(e.target.value)}
                  style={{ ...campoMotorista, width: '60px' }}
                />
                <span
                  className="font-weight-bold mx-2"
                  style={{ fontSize: '13px', whiteSpace: 'nowrap' }}
                >
                  Validade:
                </span>
                <input
                  type="date"
                  value={motoristaValidade}
                  onChange={e => setMotoristaValidade(e.target.value)}
                  style={{ ...campoMotorista, width: '150px' }}
                />
              </div>

              <div className="d-flex align-items-center mb-1">
                <span
                  className="font-weight-bold mr-2"
                  style={{ fontSize: '13px', whiteSpace: 'nowrap' }}
                >
                  Endereço:
                </span>
                <input
                  type="text"
                  value={motoristaEndereco}
                  onChange={e => setMotoristaEndereco(e.target.value)}
                  style={campoMotorista}
                />
              </div>

              <div className="d-flex align-items-center mb-1">
                <span
                  className="font-weight-bold mr-2"
                  style={{ fontSize: '13px', whiteSpace: 'nowrap' }}
                >
                  Registro Criminal:
                </span>
                <input
                  type="text"
                  value={motoristaRegistroCriminal}
                  onChange={e => setMotoristaRegistroCriminal(e.target.value)}
                  style={campoMotorista}
                />
              </div>
            </div>

            {/* BLOCO 2 - VEICULO (CAVALO MECANICO) */}
            <div className="mb-2">
              <div
                className="font-weight-bold mb-1"
                style={{ fontSize: '13px' }}
              >
                2. VEÍCULO (CAVALO MECÂNICO)
              </div>

              <div className="d-flex align-items-center mb-1">
                <span
                  className="font-weight-bold mr-2"
                  style={{ fontSize: '13px', whiteSpace: 'nowrap' }}
                >
                  Marca/Modelo:
                </span>
                <input
                  type="text"
                  value={veiculoMarcaModelo}
                  onChange={e => setVeiculoMarcaModelo(e.target.value)}
                  style={campoMotorista}
                />
              </div>

              {/* Tipo / Placa / Cor na mesma linha */}
              <div className="d-flex align-items-center mb-1 flex-wrap">
                <span
                  className="font-weight-bold mr-2"
                  style={{ fontSize: '13px', whiteSpace: 'nowrap' }}
                >
                  Tipo:
                </span>
                <input
                  type="text"
                  value={veiculoTipo}
                  onChange={e => setVeiculoTipo(e.target.value)}
                  style={{ ...campoMotorista, width: '130px' }}
                />
                <span
                  className="font-weight-bold mx-2"
                  style={{ fontSize: '13px', whiteSpace: 'nowrap' }}
                >
                  Placa:
                </span>
                <input
                  type="text"
                  value={veiculoPlaca}
                  onChange={e => setVeiculoPlaca(e.target.value)}
                  style={{ ...campoMotorista, width: '110px' }}
                />
                <span
                  className="font-weight-bold mx-2"
                  style={{ fontSize: '13px', whiteSpace: 'nowrap' }}
                >
                  Cor:
                </span>
                <input
                  type="text"
                  value={veiculoCor}
                  onChange={e => setVeiculoCor(e.target.value)}
                  style={{ ...campoMotorista, width: '100px' }}
                />
              </div>

              {/* Ano / Chassi na mesma linha */}
              <div className="d-flex align-items-center mb-1 flex-wrap">
                <span
                  className="font-weight-bold mr-2"
                  style={{ fontSize: '13px', whiteSpace: 'nowrap' }}
                >
                  Ano:
                </span>
                <input
                  type="text"
                  value={veiculoAno}
                  onChange={e => setVeiculoAno(e.target.value)}
                  style={{ ...campoMotorista, width: '90px' }}
                />
                <span
                  className="font-weight-bold mx-2"
                  style={{ fontSize: '13px', whiteSpace: 'nowrap' }}
                >
                  Chassi:
                </span>
                <input
                  type="text"
                  value={veiculoChassi}
                  onChange={e => setVeiculoChassi(e.target.value)}
                  style={campoMotorista}
                />
              </div>

              <div className="d-flex align-items-center mb-1">
                <span
                  className="font-weight-bold mr-2"
                  style={{ fontSize: '13px', whiteSpace: 'nowrap' }}
                >
                  Proprietário:
                </span>
                <input
                  type="text"
                  value={veiculoProprietario}
                  onChange={e => setVeiculoProprietario(e.target.value)}
                  style={campoMotorista}
                />
              </div>

              <div className="d-flex align-items-center mb-1">
                <span
                  className="font-weight-bold mr-2"
                  style={{ fontSize: '13px', whiteSpace: 'nowrap' }}
                >
                  CPF/CNPJ:
                </span>
                {/* CPF/CNPJ dinamico: controlado manualmente (o react-input-mask
                    trava no 11o digito da mascara de CPF e nao migra p/ CNPJ).
                    Guarda so digitos (ate 14) e formata CPF<=11 / CNPJ>=12. */}
                <input
                  type="text"
                  inputMode="numeric"
                  value={formataCpfCnpj(veiculoCpfCnpj)}
                  onChange={e =>
                    setVeiculoCpfCnpj(
                      e.target.value.replace(/\D+/g, '').slice(0, 14)
                    )
                  }
                  style={campoMotorista}
                />
              </div>
            </div>

            {/* BLOCO 3 - VEICULO (SEMIRREBOQUE) - somente nos casos em que houver */}
            <div className="mb-2">
              <div
                className="font-weight-bold mb-1"
                style={{ fontSize: '13px' }}
              >
                3. VEÍCULO (SEMIRREBOQUE){' '}
                <span
                  className="font-weight-normal font-italic"
                  style={{ fontSize: '12px' }}
                >
                  (Somente nos casos em que houver)
                </span>
              </div>

              {/* Placa / Chassi na mesma linha */}
              <div className="d-flex align-items-center mb-1 flex-wrap">
                <span
                  className="font-weight-bold mr-2"
                  style={{ fontSize: '13px', whiteSpace: 'nowrap' }}
                >
                  Placa:
                </span>
                <input
                  type="text"
                  value={semiPlaca}
                  onChange={e => setSemiPlaca(e.target.value)}
                  style={{ ...campoMotorista, width: '110px' }}
                />
                <span
                  className="font-weight-bold mx-2"
                  style={{ fontSize: '13px', whiteSpace: 'nowrap' }}
                >
                  Chassi:
                </span>
                <input
                  type="text"
                  value={semiChassi}
                  onChange={e => setSemiChassi(e.target.value)}
                  style={campoMotorista}
                />
              </div>

              <div className="d-flex align-items-center mb-1">
                <span
                  className="font-weight-bold mr-2"
                  style={{ fontSize: '13px', whiteSpace: 'nowrap' }}
                >
                  Proprietário:
                </span>
                <input
                  type="text"
                  value={semiProprietario}
                  onChange={e => setSemiProprietario(e.target.value)}
                  style={campoMotorista}
                />
              </div>

              <div className="d-flex align-items-center mb-1">
                <span
                  className="font-weight-bold mr-2"
                  style={{ fontSize: '13px', whiteSpace: 'nowrap' }}
                >
                  CPF/CNPJ:
                </span>
                {/* CPF/CNPJ dinamico controlado (mesma logica do cavalo) */}
                <input
                  type="text"
                  inputMode="numeric"
                  value={formataCpfCnpj(semiCpfCnpj)}
                  onChange={e =>
                    setSemiCpfCnpj(
                      e.target.value.replace(/\D+/g, '').slice(0, 14)
                    )
                  }
                  style={campoMotorista}
                />
              </div>
            </div>

            {/* BLOCO 4 - PJ REMETENTE DA CARGA */}
            <div className="mb-2">
              <div
                className="font-weight-bold mb-1"
                style={{ fontSize: '13px' }}
              >
                4. PJ REMETENTE DA CARGA
              </div>
              <div
                className="font-italic mb-2"
                style={{ fontSize: '11px', color: '#555' }}
              >
                (A PJ Remetente é quem emite a NF-e, enquanto o CT-e e/ou MDF-e é
                emitido pelo responsável pela “Operação de
                Transporte/Transportadora”, que pode ou não ser a PJ Remetente.)
              </div>

              <div className="d-flex align-items-center mb-1">
                <span
                  className="font-weight-bold mr-2"
                  style={{ fontSize: '13px', whiteSpace: 'nowrap' }}
                >
                  Razão social:
                </span>
                <input
                  type="text"
                  value={pjRazaoSocial}
                  onChange={e => setPjRazaoSocial(e.target.value)}
                  style={campoMotorista}
                />
              </div>

              {/* CNPJ / Data abertura / Capital social na mesma linha */}
              <div className="d-flex align-items-center mb-1 flex-wrap">
                <span
                  className="font-weight-bold mr-2"
                  style={{ fontSize: '13px', whiteSpace: 'nowrap' }}
                >
                  CNPJ:
                </span>
                <InputMask
                  type="text"
                  inputMode="numeric"
                  mask={MASK_CNPJ}
                  maskChar=""
                  value={pjCnpj}
                  onChange={e => setPjCnpj(e.target.value.replace(/\D+/g, ''))}
                  style={{ ...campoMotorista, width: '150px' }}
                />
                {/* lupa: busca dados do CNPJ do item 4 (PJ Remetente) */}
                <button
                  type="button"
                  title={
                    pjCnpj.length === 14
                      ? 'Buscar dados do CNPJ'
                      : 'Digite um CNPJ completo para buscar'
                  }
                  disabled={pjCnpj.length !== 14 || buscandoCnpj === 'pj'}
                  onClick={() =>
                    buscaCnpj(
                      'pj',
                      pjCnpj,
                      dados => {
                        setPjRazaoSocial(dados.razaoSocial);
                        setPjDataAbertura(dados.dataAbertura);
                        setPjEndereco(dados.endereco);
                      },
                      setSocios,
                      'r'
                    )
                  }
                  className="btn btn-link p-0 mr-2"
                  style={{
                    cursor:
                      pjCnpj.length === 14 && buscandoCnpj !== 'pj'
                        ? 'pointer'
                        : 'not-allowed',
                  }}
                >
                  <MDBIcon
                    icon={buscandoCnpj === 'pj' ? 'spinner' : 'search'}
                    spin={buscandoCnpj === 'pj'}
                    style={{ color: pjCnpj.length === 14 ? '#0a58ca' : '#bbb' }}
                  />
                </button>
                <span
                  className="font-weight-bold mx-2"
                  style={{ fontSize: '13px', whiteSpace: 'nowrap' }}
                >
                  Data abertura:
                </span>
                <input
                  type="date"
                  value={pjDataAbertura || ''}
                  onChange={e => setPjDataAbertura(e.target.value)}
                  style={{ ...campoMotorista, width: '150px' }}
                />
                <span
                  className="font-weight-bold mx-2"
                  style={{ fontSize: '13px', whiteSpace: 'nowrap' }}
                >
                  Capital social:
                </span>
                <input
                  type="text"
                  value={pjCapitalSocial}
                  onChange={e => setPjCapitalSocial(e.target.value)}
                  style={{ ...campoMotorista, width: '120px' }}
                />
              </div>

              <div className="d-flex align-items-center mb-1">
                <span
                  className="font-weight-bold mr-2"
                  style={{ fontSize: '13px', whiteSpace: 'nowrap' }}
                >
                  Endereço:
                </span>
                <input
                  type="text"
                  value={pjEndereco}
                  onChange={e => setPjEndereco(e.target.value)}
                  style={campoMotorista}
                />
              </div>

              {/* Coincide com a NF-e? SIM / NAO */}
              <div className="d-flex align-items-center mb-1 flex-wrap">
                <span
                  className="font-weight-bold mr-2"
                  style={{ fontSize: '13px', whiteSpace: 'nowrap' }}
                >
                  Coincide com a NF-e?
                </span>
                {/* SIM/NAO como checkbox mutuamente exclusivo (padrao Bootstrap
                    custom-control do projeto): marcar um desmarca o outro;
                    clicar no marcado limpa a resposta */}
                <div className="custom-control custom-checkbox mr-3">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="coincideSim"
                    checked={coincideNfe === 'SIM'}
                    onChange={() =>
                      setCoincideNfe(prev => (prev === 'SIM' ? '' : 'SIM'))
                    }
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="coincideSim"
                    style={{ fontSize: '13px' }}
                  >
                    SIM
                  </label>
                </div>
                <div className="custom-control custom-checkbox">
                  <input
                    type="checkbox"
                    className="custom-control-input"
                    id="coincideNao"
                    checked={coincideNfe === 'NAO'}
                    onChange={() =>
                      setCoincideNfe(prev => (prev === 'NAO' ? '' : 'NAO'))
                    }
                  />
                  <label
                    className="custom-control-label"
                    htmlFor="coincideNao"
                    style={{ fontSize: '13px' }}
                  >
                    NÃO
                  </label>
                </div>
                {coincideNfe === 'NAO' && (
                  <span
                    className="ml-3 font-italic"
                    style={{ fontSize: '11px', color: '#a00' }}
                  >
                    (há divergência: preencher a PJ Emitente da NF-e — item 5)
                  </span>
                )}
              </div>
            </div>

            {/* BLOCO 4.1 - SOCIOS (dinamico: 1..N) */}
            <RepeaterSocios
              titulo="4.1. SÓCIOS"
              idPrefix="tipoSocio"
              lista={socios}
              handlers={socioRemetente}
              socioPreenchido={socioPreenchido}
            />

            {/* BLOCO 5 + 5.1 - PJ EMITENTE DA NF-e: so quando ha divergencia
                (Coincide com a NF-e? = NAO) */}
            {coincideNfe === 'NAO' && (
              <>
                {/* BLOCO 5 - PJ EMITENTE DA NF-e */}
                <div className="mb-2">
                  <div
                    className="font-weight-bold mb-1"
                    style={{ fontSize: '13px' }}
                  >
                    5. PJ EMITENTE DA NF-e
                  </div>
                  <div
                    className="font-italic mb-2"
                    style={{ fontSize: '11px', color: '#555' }}
                  >
                    (Apenas e quando houver divergência de informação entre
                    Remetente e NF-e)
                  </div>

                  <div className="d-flex align-items-center mb-1">
                    <span
                      className="font-weight-bold mr-2"
                      style={{ fontSize: '13px', whiteSpace: 'nowrap' }}
                    >
                      Razão social:
                    </span>
                    <input
                      type="text"
                      value={emitenteRazaoSocial}
                      onChange={e => setEmitenteRazaoSocial(e.target.value)}
                      style={campoMotorista}
                    />
                  </div>

                  {/* CNPJ / Data abertura / Capital social na mesma linha */}
                  <div className="d-flex align-items-center mb-1 flex-wrap">
                    <span
                      className="font-weight-bold mr-2"
                      style={{ fontSize: '13px', whiteSpace: 'nowrap' }}
                    >
                      CNPJ:
                    </span>
                    <InputMask
                      type="text"
                      inputMode="numeric"
                      mask={MASK_CNPJ}
                      maskChar=""
                      value={emitenteCnpj}
                      onChange={e =>
                        setEmitenteCnpj(e.target.value.replace(/\D+/g, ''))
                      }
                      style={{ ...campoMotorista, width: '150px' }}
                    />
                    {/* lupa: busca dados do CNPJ do item 5 (PJ Emitente) */}
                    <button
                      type="button"
                      title={
                        emitenteCnpj.length === 14
                          ? 'Buscar dados do CNPJ'
                          : 'Digite um CNPJ completo para buscar'
                      }
                      disabled={
                        emitenteCnpj.length !== 14 ||
                        buscandoCnpj === 'emitente'
                      }
                      onClick={() =>
                        buscaCnpj(
                          'emitente',
                          emitenteCnpj,
                          dados => {
                            setEmitenteRazaoSocial(dados.razaoSocial);
                            setEmitenteDataAbertura(dados.dataAbertura);
                            setEmitenteEndereco(dados.endereco);
                          },
                          setSociosEmitente,
                          'e'
                        )
                      }
                      className="btn btn-link p-0 mr-2"
                      style={{
                        cursor:
                          emitenteCnpj.length === 14 &&
                          buscandoCnpj !== 'emitente'
                            ? 'pointer'
                            : 'not-allowed',
                      }}
                    >
                      <MDBIcon
                        icon={
                          buscandoCnpj === 'emitente' ? 'spinner' : 'search'
                        }
                        spin={buscandoCnpj === 'emitente'}
                        style={{
                          color:
                            emitenteCnpj.length === 14 ? '#0a58ca' : '#bbb',
                        }}
                      />
                    </button>
                    <span
                      className="font-weight-bold mx-2"
                      style={{ fontSize: '13px', whiteSpace: 'nowrap' }}
                    >
                      Data abertura:
                    </span>
                    <input
                      type="date"
                      value={emitenteDataAbertura || ''}
                      onChange={e => setEmitenteDataAbertura(e.target.value)}
                      style={{ ...campoMotorista, width: '150px' }}
                    />
                    <span
                      className="font-weight-bold mx-2"
                      style={{ fontSize: '13px', whiteSpace: 'nowrap' }}
                    >
                      Capital social:
                    </span>
                    <input
                      type="text"
                      value={emitenteCapitalSocial}
                      onChange={e => setEmitenteCapitalSocial(e.target.value)}
                      style={{ ...campoMotorista, width: '120px' }}
                    />
                  </div>

                  <div className="d-flex align-items-center mb-1">
                    <span
                      className="font-weight-bold mr-2"
                      style={{ fontSize: '13px', whiteSpace: 'nowrap' }}
                    >
                      Endereço:
                    </span>
                    <input
                      type="text"
                      value={emitenteEndereco}
                      onChange={e => setEmitenteEndereco(e.target.value)}
                      style={campoMotorista}
                    />
                  </div>
                </div>

                {/* BLOCO 5.1 - SOCIOS (dinamico: 1..N) */}
                <RepeaterSocios
                  titulo="5.1. SÓCIOS"
                  idPrefix="tipoSocioEmit"
                  lista={sociosEmitente}
                  handlers={socioEmitente}
                  socioPreenchido={socioPreenchido}
                />
              </>
            )}

            {/* BLOCO 6 - PJ TRANSPORTADORA (+ flag coincide CT-e/MDF-e) */}
            <BlocoPJ
              titulo="6. PJ TRANSPORTADORA"
              subtitulo="(Na hipótese do Remetente contratar uma Transportadora)"
              idPrefix="coincideCte"
              dados={transp}
              onChange={mudaPj(setTransp)}
              buscando={buscandoCnpj === 'transp'}
              onBuscarCnpj={cnpj =>
                buscaCnpj(
                  'transp',
                  cnpj,
                  dados => setTransp(prev => ({ ...prev, ...dados })),
                  setSociosTransp,
                  't'
                )
              }
              coincideLabel="Coincide com CT-e, e/ou MDF-e?"
              coincideValor={coincideCte}
              onCoincide={setCoincideCte}
              coincideAviso="(há divergência: preencher a PJ Emitente da CT-e/MDF-e — item 7)"
            />

            {/* BLOCO 6.1 - SOCIOS (PJ Transportadora) */}
            <RepeaterSocios
              titulo="6.1. SÓCIOS"
              idPrefix="tipoSocioTransp"
              lista={sociosTransp}
              handlers={socioTransp}
              socioPreenchido={socioPreenchido}
            />

            {/* BLOCO 7 + 7.1 - PJ EMITENTE DO MANIFESTO: so quando ha
                divergencia (Coincide com CT-e/MDF-e? = NAO) */}
            {coincideCte === 'NAO' && (
              <>
                <BlocoPJ
                  titulo="7. PJ EMITENTE DO MANIFESTO"
                  subtitulo="(Apenas e quando houver divergência de informação entre a Transportadora e CT-e ou MDF-e)"
                  dados={manifesto}
                  onChange={mudaPj(setManifesto)}
                  buscando={buscandoCnpj === 'manifesto'}
                  onBuscarCnpj={cnpj =>
                    buscaCnpj(
                      'manifesto',
                      cnpj,
                      dados => setManifesto(prev => ({ ...prev, ...dados })),
                      setSociosManifesto,
                      'm'
                    )
                  }
                />
                <RepeaterSocios
                  titulo="7.1. SÓCIOS"
                  idPrefix="tipoSocioManif"
                  lista={sociosManifesto}
                  handlers={socioManifesto}
                  socioPreenchido={socioPreenchido}
                />
              </>
            )}

            {/* BLOCO 8 - PJ DESTINATARIO (sempre) */}
            <BlocoPJ
              titulo="8. PJ DESTINATÁRIO"
              dados={dest}
              onChange={mudaPj(setDest)}
              buscando={buscandoCnpj === 'dest'}
              onBuscarCnpj={cnpj =>
                buscaCnpj(
                  'dest',
                  cnpj,
                  dados => setDest(prev => ({ ...prev, ...dados })),
                  setSociosDest,
                  'd'
                )
              }
            />

            {/* BLOCO 8.1 - SOCIOS (PJ Destinatario) */}
            <RepeaterSocios
              titulo="8.1. SÓCIOS"
              idPrefix="tipoSocioDest"
              lista={sociosDest}
              handlers={socioDest}
              socioPreenchido={socioPreenchido}
            />

            {/* Dinamica: editor rico (react-quill) com barra de ferramentas.
                Aceita colar/inserir imagens (base64 inline no HTML). */}
            <div
              className="font-italic mb-1"
              style={{ fontSize: '11px', color: '#777' }}
            >
              Dica: use a barra de ferramentas para formatar e inserir imagens,
              ou cole imagens (Ctrl+V) diretamente na área.
            </div>
            <EditorDinamica value={dinamica} onChange={setDinamica} />
              </>
            )}

            {ehSemDinamica && (
              <>
                <hr style={{ borderTop: '1px solid #000' }} />
                <div className="mb-3">
                  <span className="font-weight-bold" style={{ fontSize: '13px' }}>
                    1. Dados Conhecidos:
                  </span>
                  <MDBInput
                    type="textarea"
                    rows="4"
                    value={dadosConhecidos}
                    onChange={e => setDadosConhecidos(e.target.value)}
                  />
                </div>
                <div className="mb-3">
                  <span className="font-weight-bold" style={{ fontSize: '13px' }}>
                    2. Dados Solicitados:
                  </span>
                  <MDBInput
                    type="textarea"
                    rows="4"
                    value={dadosSolicitados}
                    onChange={e => setDadosSolicitados(e.target.value)}
                  />
                </div>
                <div className="mb-3">
                  <span className="font-weight-bold" style={{ fontSize: '13px' }}>
                    3. Instruções Especiais:
                  </span>
                  <MDBInput
                    type="textarea"
                    rows="4"
                    value={instrucoesEspeciais}
                    onChange={e => setInstrucoesEspeciais(e.target.value)}
                  />
                </div>
              </>
            )}

            {/* rodape: aviso da Lei */}
            <p
              className="text-center font-weight-bold mt-4"
              style={{ color: '#060', fontSize: '9px' }}
            >
              "O sigilo deste documento é protegido e controlado pela Lei Nº
              12.527/2011. A divulgação, a revelação, o fornecimento, a
              utilização ou a reprodução desautorizada de seu conteúdo, a
              qualquer tempo, meio e modo, inclusive mediante acesso ou
              facilitação de acesso indevidos, constituem condutas ilícitas que
              ensejam responsabilidades penais, civis e administrativas."
            </p>
          </div>

          {/* RESERVADO (rodape) */}
          <div className="text-center font-weight-bold mt-2" style={{ color: '#c00' }}>
            RESERVADO
          </div>
        </div>

        {/* BOTAO SALVAR (fora da folha, na mesa) */}
        <div
          className="text-center my-4 d-print-none"
          style={{ maxWidth: '820px', margin: '16px auto 0' }}
        >
          <MDBBtn color="success" disabled={salvando} onClick={salvar}>
            {salvando ? (
              <MDBSpinner small />
            ) : (
              <>
                <MDBIcon far icon="save" className="mr-2" />
                Salvar {nomeDocumento}
              </>
            )}
          </MDBBtn>
        </div>
      </div>
    </NavBar>
  );
}
